var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-box"},[_c('h3',[_vm._v("There is no data for this chart")]),_c('i',{staticClass:"v-icon material-icons theme--light",staticStyle:{"font-size":"40px"},attrs:{"aria-hidden":"true"}},[_vm._v("\n      flip_to_back\n    ")])])])
}]

export { render, staticRenderFns }